import { useState, useRef, useEffect } from 'react';
import Button from '../Button/Button';
import './ButtonMenu.scss';

function ButtonMenu({
  label,
  items = [],
  variant = 'primary',
  size,
  align = 'left',
  className = '',
}) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  // Close on outside click
  useEffect(() => {
    if (!isOpen) return;
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [isOpen]);

  // Close on Escape
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen]);

  return (
    <div className={`btn-menu ${className}`} ref={ref}>
      <div className="btn-menu__trigger">
        <Button variant={variant} size={size} onClick={() => setIsOpen(!isOpen)}>
          {label}
          <span className={`btn-menu__arrow ${isOpen ? 'btn-menu__arrow--open' : ''}`}>▼</span>
        </Button>
      </div>

      <div
        className={`btn-menu__dropdown ${isOpen ? 'btn-menu__dropdown--open' : ''} ${
          align === 'right' ? 'btn-menu__dropdown--right' : ''
        }`}
      >
        {items.map((item, i) => {
          if (item.divider) {
            return <div key={i} className="btn-menu__divider" />;
          }
          return (
            <button
              key={i}
              className={`btn-menu__item ${item.active ? 'btn-menu__item--active' : ''}`}
              onClick={() => {
                item.onClick?.();
                setIsOpen(false);
              }}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ButtonMenu;
